export default __webpack_public_path__ + "static/media/dark23.59fc6d4a.png";